import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { buildDepositReturnClaimItems } from 'domains/order/Order.mapper';
import {
  buildDepositReturnListLineKey,
  getDepositReturnListFetchStatus,
  getDepositReturnListItems,
  initDepositReturnClaimForm,
} from 'domains/order/Order.store';
import DepositReturnListTable from 'pages/MyOrdersPage/DepositReturnList/DepositReturnListTable';
import ClaimFormModal from 'pages/MyOrdersPage/OrderClaims/ClaimFormModal';
import { BlackButton, Flex, MarginBox } from 'UI';

const DepositReturnList = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const items = useSelector(getDepositReturnListItems);
  const fetchStatus = useSelector(getDepositReturnListFetchStatus);
  const [isClaimOpen, setIsClaimOpen] = useState(false);

  const handleCreateReturn = () => {
    if (items.length === 0) {
      return;
    }
    dispatch(
      initDepositReturnClaimForm({
        claimItems: buildDepositReturnClaimItems(items),
        lineKeys: items.map(buildDepositReturnListLineKey),
      }),
    );
    setIsClaimOpen(true);
  };

  return (
    <>
      <MarginBox mb={20}>
        <Flex justify={'flex-end'}>
          <BlackButton
            onClick={handleCreateReturn}
            disabled={items.length === 0}
            data-cy={'deposit-return-create-return-button'}
          >
            {t('deposit_return_list.action.create_return', 'Create Return')}
          </BlackButton>
        </Flex>
      </MarginBox>
      <DepositReturnListTable items={items} fetchStatus={fetchStatus} />
      <ClaimFormModal isOpen={isClaimOpen} setIsOpen={setIsClaimOpen} />
    </>
  );
};

export default DepositReturnList;
